import { EntrepriseContactMediationForm } from "@src/societes/form/EntrepriseContactMediationForm";
import {
  ParcoursEntrepriseStepComponentProps,
  ParcoursEntrepriseStepEnum,
} from "@src/societes/parcours/ParcoursEntreprise";
import {
  ID_FORM_ENTREPRISE,
  ParcoursEntrepriseActions,
} from "@src/societes/parcours/ParcoursEntrepriseActions";
import { ParcoursEntrepriseTemplate } from "@src/societes/parcours/ParcoursEntrepriseTemplate";

export function EntrepriseContactMediationStep({
  data,
  changeStep,
  addData,
}: ParcoursEntrepriseStepComponentProps) {
  return (
    <ParcoursEntrepriseTemplate
      title="Contact de médiation"
      actions={
        <ParcoursEntrepriseActions
          onPrevious={() =>
            changeStep(ParcoursEntrepriseStepEnum.ORGANISTATION_PROFESSIONNELLE)
          }
        />
      }
    >
      <EntrepriseContactMediationForm
        defaultValues={{
          civiliteMediation: data.civiliteMediation,
          mailMediation: data.mailMediation,
          nomMediation: data.nomMediation,
          prenomMediation: data.prenomMediation,
          telephoneMediation: data.telephoneMediation,
        }}
        onSubmit={({
          civiliteMediation,
          mailMediation,
          nomMediation,
          prenomMediation,
          telephoneMediation,
        }) => {
          const additionalData = {
            civiliteMediation,
            mailMediation,
            nomMediation,
            prenomMediation,
            telephoneMediation,
          };
          addData(additionalData);

          changeStep(ParcoursEntrepriseStepEnum.INFORMATIONS_COMPLEMENTAIRES);
        }}
        formId={ID_FORM_ENTREPRISE}
      />
    </ParcoursEntrepriseTemplate>
  );
}
